var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.productVariantData)?_c('ProductContentTabs',{attrs:{"productVariantData":_vm.productVariantData,"viewMode":_vm.viewMode,"purchased":_vm.purchased}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }